const imported = import.meta.glob('./*.ts', { eager: true })
export const stores: Record<string, Function> = {}
for (const module of Object.values(imported) as Array<object>) {
  const toBeExported = Object.entries(module)[0] as [string, Function]
  stores[toBeExported[0]] = toBeExported[1]
}
